<template>
  <div style="display: inline-block;">
    <div
      :class="buttonClasses"
      @click="showModal">
      <i class="add icon"/>
      <span>{{ $t(`patients.contentAdditionModule.${type}.add`) }}</span>
    </div>
    <div
      class="ui basic modal"
      :id="modalId">
      <div class="header">
        {{ $t(`patients.contentAdditionModule.${type}.header`, { medgateId: medgateId }) }}
      </div>
      <div class="content">
        <p>
          <b>{{ $t('patients.contentAdditionModule.objective') }}</b>
          <br>
          {{ patientObjective }}
        </p>
        <p>
          <b>{{ $t('patients.contentAdditionModule.notes') }}</b>:
          <span v-if="!patientNotes">{{ $t('patients.contentAdditionModule.notFilled') }}</span>
          <span
            v-else
            v-html="patientNotes"/>
        </p>
        <div class="ui form">
          <div
            :key="`dropdown-${dropdownKey}-items`"
            class="field">
            <label style="color: white">{{ $t(`patients.contentAdditionModule.${type}.new`) }}</label>
            <select
              multiple
              class="ui fluid search dropdown"
              :id="dropdownId"
              v-model="selectedItemIds">
              <option
                disabled
                value="">
                {{ $t('patients.contentAdditionModule.notAssigned') }}
              </option>
              <!-- Options should only consist of items (1) not deleted and (2) not previously added to patient -->
              <option
                v-for="(item, index) in newItems"
                :key="`program-item-${index}`"
                :value="item.id">
                {{ type.includes('Plan') ? item.data.title : item.data.shortName }}
              </option>
            </select>
          </div>
        </div>
        <br>
        <p
          v-if="type.includes('Plan')"
          v-html="$t(`patients.contentAdditionModule.${type}.addedOnce`)"/>
      </div>
      <div class="actions">
        <div
          class="ui left floated inverted button"
          @click="closeModal">
          {{ $t('cancel') }}
        </div>
        <div
          class="ui approve inverted primary button"
          @click="addItemsAndCloseModal">
          {{ $t('add') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentAdditionModule',
  props: {
    medgateId: {
      required: true,
      validator (value) {
        return value === null || typeof value === 'string'
      }
    },
    patientObjective: {
      type: String,
      required: true
    },
    patientNotes: {
      required: true,
      validator (value) {
        return value === null || typeof value === 'string'
      }
    },
    addedItemIds: {
      type: Array,
      required: true
    },
    newItems: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedItemIds: [],
    }
  },
  computed: {
    modalId () { return `items-addition-modal-${this._uid}` },
    dropdownId () { return `items-addition-dropdown-${this._uid}` },
    dropdownKey () { return this.newItems.length },
    type () {
      return this.camelCase(this.$options.name.split('AdditionModule')[0])
    },
    contentType () {
      return this.type.split('Plan')[0]
    },
    buttonClasses () {
      return this.type.includes('Plan') ? 'ui small teal button' : 'ui small teal basic button'
    },
    selectedItems () {
      return (
        this.selectedItemIds.map(
          itemId => this.newItems.find(item => item.id === itemId)
        )
      )
    }
  },
  methods: {
    closeModal () {
      this.selectedItemIds = []

      this.$nextTick(
        () => {
          $('#' + this.dropdownId)
            .dropdown('clear')

          $('#' + this.modalId)
            .modal('hide')
            .modal('reset')
        }
      )
    },
    addItems () {
      this.$emit('add-new-items', { items: this.selectedItems, contentType: this.contentType })
    },
    addItemsAndCloseModal () {
      this.addItems()
      this.closeModal()
    },
    showModal () {
      this.selectedItemIds = []

      $('#' + this.modalId)
        .modal({ closable: false, autofocus: false })
        .modal('show')

      $('#' + this.dropdownId)
        .dropdown()
    }
  },
  beforeDestroy () {
    let modal = $('#' + this.modalId)
    if (modal) { modal.remove() }
  }
}
</script>

<style scoped>
.modules-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
